import FlatButton from 'material-ui/FlatButton'
import React, { Component } from 'react'

class TopMenuButtonLong extends Component {
  render() {
    return <FlatButton {...this.props} />
  }
}

export default TopMenuButtonLong
